export default {
  bad: [
  ],
  good: [
  ]
};
